module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"perPageItem":{"null":"All"}}}')
  delete Component.options._Ctor
}
